import { get } from 'lodash-es';

const idToken2User = (tokenObj) => {
  console.log(tokenObj);
  return {
    id: get(tokenObj, 'sub'),
    name: get(tokenObj, 'name'),
    email: get(tokenObj, 'email'),
    expiry: get(tokenObj, 'exp'),
    role: get(tokenObj, 'role'),
  };
};

export default idToken2User;
